module.exports = __webpack_public_path__ + "static/johntroy-2f80ce0110eb63abe2ed65c752fad070.jpeg";